import { css } from 'styled-components';
export const basicStyle = _ref => {
  let {
    width,
    height,
    $fit
  } = _ref;
  return css(["width:", ";height:", ";max-width:100%;max-height:100%;", ""], width, height, $fit && `
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    max-width: 100%;
    max-height: 100%;
  `);
};
//# sourceMappingURL=IframeWrapper.style.js.map